import {FormDataRepository} from '../../domain/shared/repositories/FormDataRepository';
import {AssignmentFormData, DeliveryFormData} from '../../domain/shared/entities/FormData';

export class FormDataService {
  constructor(private readonly formDataRepository: FormDataRepository) {}

  async getAssignmentFormData(): Promise<AssignmentFormData> {
    return await this.formDataRepository.getAssignmentFormData();
  }

  async getDeliveryFormData(): Promise<DeliveryFormData> {
    return await this.formDataRepository.getDeliveryFormData();
  }
}
